import React from "react";
import { Link } from "react-router-dom"
import { Card, CardBody, Progress, Row, Col } from 'reactstrap';
import { Popup } from 'semantic-ui-react'
import moment from "moment";



const status_ = {
  'AEREA': <i className='fas fa-plane' style={{ fontSize: '2.5em', color: '#656565' }}></i>,
  'MARITIMA': <i className='fas fa-ship' style={{ fontSize: '2.5em', color: '#656565' }}></i>,
  'TERRESTRE': <i className='fas fa-truck' style={{ fontSize: '2.5em', color: '#656565' }}></i>
};

export const CardInternacional = props => {
  let { element } = props;
  let limit = 10
  return (
    <>
      <Card className="_clickCard myCard" id={element.id}>
        <CardBody style={{ textAlign: 'center', fontSize: '12px', padding: '10px 12px 10px 12px' }}>
          <Row>
            <Col md={1} lg={2} sm={6}>
              <Row>
                <Col xs={3}>
                  <div>
                    {status_[element.ModoTransporte]}
                  </div>
                </Col>
                <Col xs={9}>
                  <div>
                    <b>Shipment No.</b>
                  </div>
                  <Link to={'/shipmentsDetail/' + element.ShipmentId} style={{ textDecoration: 'none' }}>
                    <div>
                      <span style={{ fontSize: '12.5px', color: '#0097dc', fontWeight: 'bold' }}>{element.ShipmentNumber}</span>
                    </div>
                  </Link>
                </Col>
                <Col xs={12}>
                  <div style={{ textAlign: 'left' }}>
                    <span style={{ fontSize: '12px', fontWeight: 'bold' }}>{element.Estatus}</span>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col md={3} lg={1} sm={6}>
              <div>
                <b>Customer</b>
              </div>
              <Popup
                content={element.Customer ? element.Customer : 'No Information'}
                position='bottom left'
                wide
                // inverted
                // style={style}
                trigger={
                  <div>
                    {`${element.Customer ? element.Customer.substring(0, limit) : ''}...`}
                  </div>
                }>
              </Popup>
            </Col>
            <Col md={3} lg={1} sm={6}>
              <div>
                <b>Supplier</b>
              </div>
              <div>
                {/* {element.SupplierName} */}
                <Popup
                  content={element.SupplierName ? element.SupplierName : 'No Information'}
                  position='bottom left'
                  wide
                  // inverted
                  // style={style}
                  trigger={
                    <div>
                      {`${element.SupplierName ? element.SupplierName.substring(0, limit) : ''}...`}
                    </div>
                  }>
                </Popup>
              </div>
            </Col>
            <Col md={3} lg={1} sm={6}>
              <div>
                <b>Consignee</b>
              </div>
              <div>
                {/* {element.ConsigneeName ? element.ConsigneeName : '---'} */}
                <Popup
                  content={element.ConsigneeName ? element.ConsigneeName : 'No Information'}
                  position='bottom left'
                  wide
                  // inverted
                  // style={style}
                  trigger={
                    <div>
                      {`${element.ConsigneeName ? element.ConsigneeName.substring(0, limit) : ''}...`}
                    </div>
                  }>
                </Popup>
              </div>
            </Col>

            <Col md={3} lg={1} sm={6}>
              <div>
                <b>Customer Ref.</b>
              </div>
              <div>
                <Popup
                  content={element.ClientRef ? element.ClientRef : 'No Information'}
                  position='bottom left'
                  wide
                  // inverted
                  // style={style}
                  trigger={
                    <div>
                      {`${element.ClientRef ? element.ClientRef.substring(0, limit) : ''}...`}
                    </div>
                  }>
                </Popup>
              </div>
            </Col>
            <Col md={3} lg={1} sm={6}>
              <div>
                <b>Containers</b>
              </div>
              <div>
                <Popup
                  content={element.NoContainer ? element.NoContainer : 'No Information'}
                  position='bottom left'
                  wide
                  // inverted
                  // style={style}
                  trigger={
                    <div>
                      {`${element.NoContainer ? element.NoContainer.substring(0, limit) : ''}...`}
                    </div>
                  }>
                </Popup>
              </div>
            </Col>
            <Col md={3} lg={1} sm={6}>
              <div>
                <i className="fas fa-map-marker-alt mr-2"></i>
                <b>From</b>
              </div>
              <div>
                {element.POL}
              </div>
            </Col>

            <Col md={3} lg={1} sm={6}>
              <div>
                <i className="fas fa-map-marker-alt mr-2"></i>
                <b>To</b>
              </div>
              <div>
                {element.POD}
              </div>
            </Col>

            <Col md={3} lg={1} sm={6}>
              <div>
                <b>{element.TransportMode === 'InLand' ? 'PickUp' : 'ETD'}</b>
              </div>
              <div>
                {element.TransportMode === 'InLand' ? moment(element.FRDPP).format('DD-MM-YYYY') : element.ETD}
              </div>
            </Col>
            <Col md={3} lg={1} sm={6}>
              <div>
                <b>{element.TransportMode === 'InLand' ? 'ATA to Final Destination' : 'ETA'}</b>
              </div>
              <div>
                {element.TransportMode === 'InLand' ? element.ATA : element.ETA}
              </div>
            </Col>
            <Col md={12} lg={1} sm={6}>
              <div style={{ textAlign: 'left' }}>
                {element.LastUpdate < 50 ? (element.LastUpdate ? <span style={{ color: 'green' }}>On Time</span> : <span style={{ color: 'red' }}>Delayed</span>) : <span style={{ color: 'green' }}>On Time</span>}
              </div>
              <div>
                <Progress color={element.LastUpdate < 50 ? (element.LastUpdate ? 'success' : 'danger') : 'success'} value={element.Progress} />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};
